import { render, staticRenderFns } from "./ThesisForm.vue?vue&type=template&id=ecb0d690&scoped=true&"
import script from "./ThesisForm.vue?vue&type=script&lang=js&"
export * from "./ThesisForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb0d690",
  null
  
)

export default component.exports